// src/utils/pdfUtils.js
import { PDFDocument } from "pdf-lib";

export const removePagesByIndex = async (pdfBytes, pagesToRemove = []) => {
  const pdfDoc = await PDFDocument.load(pdfBytes);
  const totalPages = pdfDoc.getPageCount();
  const newPdfDoc = await PDFDocument.create();

  for (let i = 0; i < totalPages; i++) {
    if (!pagesToRemove.includes(i)) {
      const [copiedPage] = await newPdfDoc.copyPages(pdfDoc, [i]);
      newPdfDoc.addPage(copiedPage);
    }
  }

  return await newPdfDoc.save(); // returns Uint8Array
};
